interface GroupCompanyHeaderProps {
  title: string;
  subheading?: string;
}

export default function GroupCompanyHeader({ title, subheading }: GroupCompanyHeaderProps) {
  return (
    <header>
      <h1 className="hero-title text-[#0a0a0a]">{title}</h1>
      {subheading && (
        <div
          className="hero-subtitle mt-4 text-[#0a0a0a] [&_p]:mt-0"
          dangerouslySetInnerHTML={{ __html: subheading }}
        />
      )}
    </header>
  );
}
